import VueRouter from "vue-router";
import { BaseGoToHelper } from "./goToHelper";
import { $t } from "./t";

export enum TagRouteNames {
  TAG_TABLE = "TAG_TABLE",
  TAG_DETAIL = "TAG_DETAIL"
}

type Tab = { newTab?: boolean };
type Partner = { partnerId: string };
type Tag = { tagId: string };
type Query = { query?: Record<string, string> };

export class TagGoToHelper extends BaseGoToHelper {
  static get breadCrumbs() {
    const locations = TagGoToHelper.locations;

    return {
      TagTable: (partnerId: string) => {
        return {
          text: $t("tag.tags").toString(),
          exact: true,
          to: locations.tagTable({ partnerId })
        };
      },
      TagDetail: (partnerId: string, tagId: string) => {
        return {
          text: $t("tag.tag").toString(),
          exact: true,
          to: locations.tagDetail({ partnerId, tagId })
        };
      }
    };
  }

  constructor(protected readonly router: VueRouter) {
    super(router);
  }

  static locations = {
    tagTable: (d: Partner & Query) => {
      return {
        name: TagRouteNames.TAG_TABLE,
        params: { partnerId: d.partnerId },
        query: d.query
      };
    },
    tagDetail: (d: Partner & Tag & Query) => {
      return {
        name: TagRouteNames.TAG_DETAIL,
        params: { partnerId: d.partnerId, tagId: d.tagId },
        query: d.query
      };
    }
  };

  goToTagTable(d: Tab & Partner) {
    this.go(TagGoToHelper.locations.tagTable(d), d.newTab);
  }

  goToTagDetail(d: Tab & Partner & Tag) {
    this.go(TagGoToHelper.locations.tagDetail(d), d.newTab);
  }
}
